<template>
	<div class="erji">
		<div class="container">
			<div class="main">
				<div class="work">
					<div class="main4-list">
						<div class="row">
							<div class="col-lg-4 col-md-6" v-for="(item,index) in workMenu" :key="index">
								<div class="title-00">
									<h1 class="fl">{{item.name}}</h1>
									<div class="fr" @click="toList(item)">更多+</div>
									<div class="clear"></div>
								</div>
								<div class="main4-list-div">
									<list :listId="item.id" :piece="piece_work"></list>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
	  name: 'work',
		data(){
			return{
				workMenu:[],
				piece_work:9,
			}
		},
		methods:{
			//请求重点工作栏目
			res_menu_work(){
				this.axios.get('/api/menus/parentNumber?id='+ this.$route.query.category_id)
					.then(response => {
						// 处理成功情况
						if(response.data.code == 200){
							this.workMenu = response.data.reslut;
						}
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
			},
			toList(item){
				console.log("toList",item);
				console.log("toList_route",this.$route);
				this.$router.push({
					path:'/slider/'+ item.parent_id +'/elist??category_id='+item.category_id,
					query:{
						category_id:item.id
					}
				})
			}
		},
		created() {
			this.res_menu_work();
			
		},
		mounted(){
		
		}
	}
</script>

<style>
</style>